/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../global-client';
import type { RequestConfig, ResponseErrorConfig } from '../../global-client';
import type { GetApiUsersMeQueryResponseSchema, GetApiUsersMe401Schema } from '../types/getApiUsersMeSchema';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { getApiUsersMe } from '../api/getApiUsersMe';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiUsersMeQueryKey = () => ['global', { url: '/api/users/me' }] as const;

export type GetApiUsersMeQueryKey = ReturnType<typeof getApiUsersMeQueryKey>;

export function getApiUsersMeQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiUsersMeQueryKey();
  return queryOptions<
    GetApiUsersMeQueryResponseSchema,
    ResponseErrorConfig<GetApiUsersMe401Schema>,
    GetApiUsersMeQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiUsersMe(config);
    },
  });
}

/**
 * @summary Retrieves current user
 * {@link /api/users/me}
 */
export function useGetApiUsersMe<
  TData = GetApiUsersMeQueryResponseSchema,
  TQueryData = GetApiUsersMeQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiUsersMeQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiUsersMeQueryResponseSchema,
        ResponseErrorConfig<GetApiUsersMe401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiUsersMeQueryKey();

  const query = useQuery(
    {
      ...getApiUsersMeQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiUsersMe401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
